const routes = [
  {
    path: '/settings/reviews',
    name: 'ReviewsPage',
    component: () => import(/* webpackChunkName: "ReviewsPage" */ './views/ReviewsPage.vue'),
    meta: { i18n: 'reviews-pov', pageNameEn: 'Reviews Settings' },
  },
];

export default routes;
